/** Boot: fonts (ADR-0028, no CDN), tokens, theme, then the React root (ADR-0008). */
import "@fontsource-variable/inter";
import "@fontsource-variable/playfair-display";
import "@fontsource-variable/source-serif-4";
import "@gxs/design-tokens/tokens.css";
import "./theme/theme.css";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./shell/App";

const root = document.getElementById("root");
if (root !== null) createRoot(root).render(createElement(App));
